var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webapp"},[_c('basic-container',[_c('avue-form-design',{attrs:{"options":_vm.options},on:{"submit":_vm.handleSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }